import type { DiagramProps } from '@/lib/scad-feature-types';
import { D } from './DiagramStyles';

export function IntersectionDiagram(_props: DiagramProps) {
  return (
    <svg viewBox="0 0 280 150" width="100%" style={{ display: 'block' }} aria-label="Intersection diagram">
      <defs>
        {/* Clip to show only overlap region in result */}
        <clipPath id="isect-rect-clip">
          <rect x={158} y={52} width={55} height={50} />
        </clipPath>
      </defs>

      {/* A: rectangle */}
      <rect x={30} y={52} width={55} height={50}
            fill="rgba(96,165,250,0.12)" stroke={D.GEO_STROKE} strokeWidth="1.5" />
      <text x={57} y={44} fontSize="10" fontFamily="monospace"
            fill="currentColor" opacity="0.6" textAnchor="middle">A</text>

      {/* B: circle overlapping */}
      <circle cx={72} cy={77} r={28}
              fill="rgba(34,197,94,0.12)" stroke="#22c55e" strokeWidth="1.5" />
      <text x={95} y={44} fontSize="10" fontFamily="monospace"
            fill="#22c55e" opacity="0.8" textAnchor="middle">B</text>

      {/* Overlap highlight in A∩B */}
      <rect x={47} y={52} width={38} height={50}
            fill="rgba(96,165,250,0.25)" clipPath="url(#isect-rect-clip-src)" />
      <clipPath id="isect-rect-clip-src">
        <circle cx={72} cy={77} r={28} />
      </clipPath>
      <rect x={47} y={52} width={38} height={50}
            fill="rgba(251,191,36,0.3)" stroke="none"
            clipPath="url(#isect-rect-clip-src)" />

      {/* Intersection symbol */}
      <text x={113} y={83} fontSize="16" fontFamily="monospace"
            fill="currentColor" opacity="0.5" textAnchor="middle">∩</text>
      <text x={130} y={83} fontSize="14" fontFamily="monospace"
            fill="currentColor" opacity="0.4" textAnchor="middle">=</text>

      {/* Result: only the lens-shaped overlap */}
      {/* Approximate with a circle clipped to rect */}
      <rect x={158} y={52} width={55} height={50}
            fill="rgba(251,191,36,0.35)" stroke="#f59e0b" strokeWidth="1.5"
            clipPath="url(#isect-result-clip)" />
      <clipPath id="isect-result-clip">
        <circle cx={200} cy={77} r={28} />
      </clipPath>

      <text x="140" y="142" fontSize="9" fontFamily="monospace"
            fill="currentColor" opacity="0.4" textAnchor="middle">only the overlapping volume is kept</text>
    </svg>
  );
}
